// 3rd-party modules
import 'moment-jalaali';
import moment from 'moment-jalaali';

export function getDayName(date?: Date) {
  return moment(date).format('dddd');
}

export function getFormatDate(language: string, date?: Date) {
  return language === 'fa'
    ? moment(date).format('jYYYY/jMM/jDD')
    : moment(date).format('YYYY/MM/DD');
}

export function getFormatDateWithDay(language: string, date?: Date) {
  return language === 'fa'
    ? moment(date).format('jD jMMMM jYYYY') // "۲۳ فروردین ۱۴۰۴"
    : moment(date).format('MMMM D, YYYY'); // "April 16, 2024"
}

export function getFormatDateWithDayName(language: string, date?: Date) {
  return language === 'fa'
    ? moment(date).format('dddd، jD jMMMM jYYYY') // "سه‌شنبه، ۲۶ فروردین ۱۴۰۳"
    : moment(date).format('dddd, MMMM D, YYYY'); // "Tuesday, April 16, 2024"
}
